import config from "../config";

/**
 * Ticket Quality Review — gated by the LaunchDarkly `qa-review` flag
 * (including camelCase variants commonly returned by `useFlags()`).
 *
 * The flag is targeted the same way the other supervisor gates are: on the
 * `user` context this app already sends, matched by its `mspName` attribute.
 * Nothing is stored in the DB; the review is generated on demand and shown
 * in a popup dialog.
 */
const QA_REVIEW_FLAG_KEYS = ["qa-review", "qaReview", "qareview"];

export function isTicketQualityReviewLdEnabled(
  flags: Record<string, unknown> | undefined
): boolean {
  // No client-side id means no flags at all, so local development would lose
  // the feature entirely rather than have it switched off. Same exception the
  // browser-use gate makes.
  if (process.env.NODE_ENV === "development" && !config.launchdarklyClientSideId) {
    return true;
  }
  if (!flags || typeof flags !== "object") {
    return false;
  }
  return QA_REVIEW_FLAG_KEYS.some((key) => flags[key] === true);
}
